export default __webpack_public_path__ + "static/media/madame_detail8.b8f07ae2.jpg";